import { MenuLinkWrapper } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/MenuWrapper'
import { useShouldShowSourcingUpsell } from '@app/src/components/SourcingSolutionPromo/useShouldShowSourcingUpsell'
import { SourcingRecommendationView } from '@app/src/pages/SourcingRecommendation/sourcingRecommendation'
import { useDueDiligenceIntent } from '@app/src/pages/SourcingRecommendation/useDueDiligenceIntent'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import paths from '@app/src/wf-constants/paths'
import { KeyboardReturn, LightbulbOutlined } from '@mui/icons-material'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { generatePath } from 'react-router-dom'
import SourcingPromoCard from './SourcingPromoCard'

const prefix = 'sourcingRecommendation.navigation'

const YourRecommendationLink: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <MenuLinkWrapper
      icon={<LightbulbOutlined fontSize="small" />}
      promoted
      title={formatMessage({ id: `${prefix}.yourRecommendation` })}
      menuItems={{
        link: generatePath(paths.sourcingRecommendation, { view: SourcingRecommendationView.Recommendation }),
      }}
    />
  )
}

/**
 * An organization that has answered keeps its way back to the result, whatever the upsell rules say now:
 * those turn on its solution mix and size data, which have nothing to do with having answered.
 */
export const SourcingPromoSlot: React.FC = () => {
  const showPromo = useShouldShowSourcingUpsell()
  const { hasIntent, isLoading } = useDueDiligenceIntent()

  if (isLoading) return null

  if (hasIntent)
    return (
      <Box px={1} pb={1}>
        <YourRecommendationLink />
      </Box>
    )

  return showPromo ? <SourcingPromoCard /> : null
}

/** The recommendation is a focused flow, so it replaces the app's navigation rather than sitting inside it. */
export const SourcingRecommendationNavigation: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Stack>
      <YourRecommendationLink />
      <MenuLinkWrapper
        icon={<KeyboardReturn fontSize="small" />}
        title={formatMessage({ id: `${prefix}.backToHome` })}
        menuItems={{ link: navigationLinks.dashboard }}
      />
    </Stack>
  )
}
